// Libraries
import { TriangleDownIcon } from '@chakra-ui/icons';
import { Avatar, Button, Flex, Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
// Types
import { AvatarButtonProps } from './AvatarButton.type';

/**
 * AvatarButton component displays an avatar with a dropdown button.
 * @component
 * @param {AvatarButtonProps} props - The component props.
 * @param {string} props.name - The name of the user. Optional.
 * @param {string} props.src - The url to the picture of the user. Optional.
 * @param {ReactNode} props.children - The content for the popover.
 * @returns {ReactElement} - The AvatarButton component.
 */
export const AvatarButton = ({ name, src, children }: AvatarButtonProps) => {
  return (
    <Popover placement='bottom-end'>
      <PopoverTrigger>
        <Button p={1} h={10} colorScheme='navScheme'>
          <Flex gap={2} alignItems='center'>
            <Avatar w={8} h={8} name={name} src={src} bg='gray.400' color='white' />
            <TriangleDownIcon color='white' h={2.5} w={2.5} />
          </Flex>
        </Button>
      </PopoverTrigger>
      <PopoverContent w='fit-content'>{children}</PopoverContent>
    </Popover>
  );
};
